import { Box, Text, Divider } from '@wix/design-system';
import React, { useContext } from 'react';
import { RicosContext, EditorContext, ModalContext } from 'ricos-context';
import { FloatingLayout } from 'wix-rich-content-ui-components';
import { INSERT_POLL_MODAL_ID } from '../../consts.js';
import { PRESET_SELECTOR_MODAL } from '../../dataHooks.js';
import { POLL_TYPE } from '../../types.js';
import { createInitialPollData } from './preset-data.js';
import { PresetPicker } from './preset-picker.js';
import 'ricos-schema';
import 'lodash';
import 'wix-rich-content-editor-common';
import '../../defaults.js';
import '../../helpers.js';
import 'ricos-schema/next';
import 'wix-rich-content-common/libs/imageUtils';
import '../../style-inject.es-e7b07dd7.js';
import '../../assets/icons/ListPollIcon.js';
import '../../assets/icons/WithImagePollIcon.js';
import '../../assets/icons/GridPollIcon.js';

const InsertModal = ({ config }) => {
  const { t, isMobile } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const modalService = useContext(ModalContext);
  const closeModal = () => modalService.closeModal(INSERT_POLL_MODAL_ID);
  const onPollAdd = (type) => {
    const pollData = createInitialPollData(config, type);
    queueMicrotask(() => getEditorCommands().insertBlockWithBlankLines(POLL_TYPE, pollData));
    closeModal();
  };
  return /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      sidePanelProps: isMobile ? {} : { width: "420px" },
      dataHook: PRESET_SELECTOR_MODAL,
      header: isMobile ? {
        title: "Poll"
      } : {
        title: t("Poll_Presets_Popup_Title"),
        subtitle: t("Poll_Presets_Popup_Subtitle"),
        showDivider: true
      },
      onCloseButtonClick: isMobile ? closeModal : void 0,
      content: {
        noPadding: isMobile,
        children: /* @__PURE__ */ React.createElement(React.Fragment, null, isMobile && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { direction: "vertical", marginLeft: "SP2", marginRight: "SP2", marginBottom: "SP2" }, /* @__PURE__ */ React.createElement(Text, { weight: "bold" }, t("Poll_Presets_Popup_Title")), /* @__PURE__ */ React.createElement(Text, { weight: "thin" }, t("Poll_Presets_Popup_Subtitle"))), /* @__PURE__ */ React.createElement(Divider, null)), /* @__PURE__ */ React.createElement(PresetPicker, { onPollAdd }))
      }
    }
  );
};

export { InsertModal };
//# sourceMappingURL=insert-modal.js.map
